import { render, staticRenderFns } from "./Loginpage.vue?vue&type=template&id=6f26da06&scoped=true"
import script from "./Loginpage.vue?vue&type=script&lang=js"
export * from "./Loginpage.vue?vue&type=script&lang=js"
import style0 from "./Loginpage.vue?vue&type=style&index=0&id=6f26da06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f26da06",
  null
  
)

export default component.exports